import Raven from 'raven-js';

export default (type, error, payload) => {
  Raven.captureException(error);
  const message = error.message || error;

  return {
    type,
    payload,
    error: message,
  };
};



// WEBPACK FOOTER //
// ./src/modules/errorAction.js